<template>
  <LayoutLogin>
    <template v-slot:content>
      <v-sheet rounded min-width="450px" color="white" elevation="12px">
        <v-progress-linear
          height="6"
          :active="isLoading"
          :indeterminate="isLoading"
        />
        <div class="pa-11">
          <div class="d-flex justify-center mb-8 mt-6">
            <Logo type="big" />
          </div>

          <p class="body-1 text-center blue--text" data-private>
            {{ $t('common.greetings.welcome_admiration_sign') }}
          </p>
          <p class="body-1 text-center">
            {{ $t('auth.access.lets_confirm_your_location') }}
          </p>
          <AccessLocationView
            :organizationId="access.organizationId"
            :submitText="$t('common.button.save_and_continue')"
            :location="location"
            :isButtonDisabled="!hasCompleteLocation"
            @onLocationChange="onLocationChange"
            @onSubmit="onSubmit"
            @onCheckboxChecked="onCheckboxChecked"
          />
        </div>
      </v-sheet>
    </template>
  </LayoutLogin>
</template>

<script>
import AccessLocationView from '@/components/Access/AccessLocationView.vue'

import LayoutLogin from '@/components/Core/Layout/LayoutLogin.vue'

import Logo from '@/components/Core/Logo/Logo.vue'
import mixin from '@/mixins/mixin.vue'

import _ from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CompleteLocationView',

  components: {
    AccessLocationView,
    LayoutLogin,
    Logo,
  },

  mixins: [mixin],

  data() {
    return {
      localLocation: {
        site: '',
        tags: [],
      },
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      access: state => state.access,
    }),

    location() {
      return {
        site:
          _.get(this.access, 'account.site')?._id || this.localLocation.site,
        tags: _.get(this.access, 'account.tags') || this.localLocation.tags,
      }
    },

    hasCompleteLocation() {
      return Boolean(this.location.site)
    },
  },

  methods: {
    ...mapActions({
      updateLocationAttributes: 'updateLocationAttributes',
      updateAccountNotificationSettings: 'updateAccountNotificationSettings',
    }),

    onLocationChange(location) {
      this.localLocation.site = location.site
      this.localLocation.tags = location.tags
    },

    async onSubmit() {
      this.isLoading = true
      try {
        const organizationId = this.access.organizationId
        const accountId = this.access.account._id

        await this.updateLocationAttributes({
          organizationId,
          accountId,
          location: this.localLocation,
        })
        this.navigateTo(this.$route.query?.redirect ?? '/home')
      } catch (err) {
        this.isLoading = false
        this.showError(err)
      }
    },

    async onCheckboxChecked(values) {
      try {
        const organizationId = this.access.organizationId
        const accountId = this.access.account._id

        const data = {
          receiveEmailNotifications: values.send_me_email_notifications,
        }

        return await this.updateAccountNotificationSettings({
          organizationId,
          accountId,
          data,
        })
      } catch (error) {
        this.showError(error)
      }
    },
  },
}
</script>
